











































































import Vue from "vue"
import settings from '@/settings'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import element_cell from '@/components/vpe/element_cell'

export default {
    name: 'company_variable_payroll_sending'

    components: { Menus, element_cell }

    props:
        uj_set:
            required: true
        vp_custom_vp_dated_set:
            required: true
        date:
            required: true

    data: ()->
        evp_state_classes: @$store.state.evp_state_classes
        vpc_to_bind_text: "Vous devez paramétrer toutes les colonnes pour l'envoi au logiciel de paie. Pour ce faire, allez sur le menu Import/Export -> Synchronisation logiciel de paie -> onglet Paramètrage des EVP."
        result_dialog_visible: false
        result: {
            ok_abs: false
            ok_vpe: false
            errors_vpe: ""
            errors_abs: ""
        }

    computed:
        data_filtered: ()->
            self = @
            data = @uj_set.filter (x) ->
                start_date = self.date_formatter(x.start)

                !self.search || x.user.user_info.lastname.toLowerCase().includes(self.search.toLowerCase()) \
                || start_date.includes(self.search.toLowerCase()) \
                || x.user.user_info.firstname.toLowerCase().includes(self.search.toLowerCase()) \
                || x.job.name.toLowerCase().includes(self.search.toLowerCase())
            @users_counting(data)
            return data

        end_button_text: ()->
            text = "Clore ces EVP"
            # console.log "AS ", @$store.getters.current_company.has_accounting_software
            if @$store.getters.current_company.has_accounting_software
                text = "Envoyer à mon logiciel de comptabilité"
            return text

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        close_result_dialog: ()->
            # console.log "CLOSE RESULT"
            @result_dialog_visible = false
            @$router.push({name:"company_variable_payroll", params:{date_prop:@date}})
            .catch((err)-> {})
            return

        download_zipfile: ()->
            # console.log "DOWNLOAD ZIP", settings.vpe_zipfile
            uid_set = @uj_set.map (x)->
                return x.vp_dated_user_job.uid
            Vue.http({
                method: 'post',
                url: settings.vpe_zipfile,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({"company_uid":@$store.getters.current_company.uid, "uid_set":uid_set, "date":@date}),
                responseType: 'arraybuffer'
            })
            .then (resp)->
                # console.log "RESP", resp
                url = window.URL.createObjectURL(new Blob([resp.data]), {type:'application/zip'})
                link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'EVP.zip')
                link.click()
            .catch (error)->
                console.log 'download error', error
            return

        element_set_picker: (row, vpc_vpd_uid)->
            ret = []
            if row.vp_dated_user_job?
                for el_set in row.vp_dated_user_job.vp_element_set_group
                    if el_set.vp_custom_vp_dated_uid == vpc_vpd_uid
                        ret = el_set.element_set
                        break 
            return ret

        dialog_title: (row, vpc)->
            return vpc.name+" - "+row.user.user_info.lastname+" "+row.user.user_info.firstname+" - "+row.job.name

        span_method: ({ row, column, rowIndex, columnIndex })->
            if columnIndex == 0
                user_str = row.user.user_info.lastname+" "+row.user.user_info.firstname
                if rowIndex == 0
                    return [@counted_users[user_str], 1]
                else
                    if user_str != @data_filtered[rowIndex - 1]['user']['user_info']['lastname']+" "+@data_filtered[rowIndex - 1]['user']['user_info']['firstname']
                        return [@counted_users[user_str], 1]
                    else
                        return [0, 0]
            return

        users_counting: (datas)->
            @counted_users = datas
                .map (x)->
                    return x.user.user_info.lastname+" "+x.user.user_info.firstname
                .reduce (acc, user_str)->
                    if user_str in Object.keys(acc)
                        acc[user_str] += 1
                    else
                        acc[user_str] = 1
                    return acc
                , {}
            # console.log "USERS_COUNTING", @counted_users
            return

        ending_evp: ()->
            # console.log "DATE", @date
            self = @
            if @$store.state.selected_company.has_accounting_software and @$store.state.selected_company.has_vpc_to_bind
                n.warning(@vpc_to_bind_text)
                return
            tmp_text = "clore ces evp"
            if @$store.state.selected_company.has_accounting_software
                tmp_text = "envoyer ces evp à votre logiciel de comptabilité"
            vpduj_uid_set = @uj_set.map (x)-> return x.vp_dated_user_job.uid
            # console.log "VPDUJ UID SET", vpduj_uid_set
            h = this.$createElement
            @$confirm("", 'Confirmation', {
                message: h('p', null, [
                    h('span', null, "Êtes-vous sûr·e de vouloir "+tmp_text+" ? "),
                    h('span', { style: 'color: red; font-weight: bold;' }, 'Après confirmation, vous ne pourrez plus les modifier.')
                  ]),
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "ENDING EVP", vpduj_uid_set
                    self.$http.post(settings.send_or_close_vpe, {"company_uid": self.$store.getters.current_company.uid, "vpduj_uid_set": vpduj_uid_set, "date":self.date})
                    .then (resp)->
                        # console.log "SEND OR CLOSE RESP", resp
                        if resp.body.status
                            # console.log "SUCCESS", resp.body.message
                            n.success()
                            self.$router.push({name:"company_variable_payroll", params:{date_prop:self.date}})
                            .catch((err)-> {})
                        else if resp.body.status == "vpc_to_bind"
                            n.warning(self.vpc_to_bind_text)
                        else if resp.body.ok_vpe? or resp.body.ok_abs?
                            self.result = resp.body
                            self.result_dialog_visible = true
                        else
                            n.error(resp.body.error, resp.body.error_trad)
                .catch (cancel)->
                    return

    beforeMount: ()->
        # console.log "beforeMount company_variable_payroll_sending", @uj_set, @date
        if @uj_set is undefined
            @$router.push({name:"company_variable_payroll", params:{date_prop:@date}})
            .catch((err)-> {})
}
